import { render, staticRenderFns } from "./IBMMQCsRes.vue?vue&type=template&id=6cbf0600&scoped=true&"
import script from "./IBMMQCsRes.vue?vue&type=script&lang=js&"
export * from "./IBMMQCsRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf0600",
  null
  
)

export default component.exports